const SUBSCRIPTION_REQUIRED_STREAM_REGEX = /^.+\/subscriptionrequired\.\w+\.mp3$/;
export function isSubscriptionRequiredStream(stream) {
    try {
        return SUBSCRIPTION_REQUIRED_STREAM_REGEX.test(stream.url);
    }
    catch {
        return false;
    }
}
export function isHls(url) {
    return url.includes('.m3u8');
}
